import {
  createApiFactory,
  createPlugin,
  createComponentExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { loggingApiRef, LoggingApiClient } from './api';

export const loggingPlugin = createPlugin({
  id: 'logging',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: loggingApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory({ discoveryApi, fetchApi }) {
        return new LoggingApiClient({ discoveryApi, fetchApi });
      },
    }),
  ],
});

export const LoggingPage = loggingPlugin.provide(
  createComponentExtension({
    name: 'LoggingPage',
    component: {
      lazy: () => import('./components/LoggingPage').then(m => m.LoggingPage),
    },
  }),
);
